export default __webpack_public_path__ + "static/media/win.e72d25b9.mp3";